import React from 'react';
import { BundleSizeBtn, SelectorLabel } from '../../styles';

const BoxSizeSelector = ({ limit, sizes, handleLimitChange, nolabel }) => {
  return (
    <div className='d-flex flex-column align-items-center'>
      {!nolabel && (
        <SelectorLabel htmlFor="bundle-size-selector">Box Size</SelectorLabel>
      )}
      <div id="bundle-size-selector">
        <BundleSizeBtn
          className={`bundle-size-btn ${limit === sizes.small ? 'active' : ''}`}
          onClick={handleLimitChange}
        >
          {sizes.small}
        </BundleSizeBtn>
        {/* 
        // ! Lolas no longer offers 'large' size box
        <BundleSizeBtn
          className={`ml-2 ${limit === sizes.large ? 'active' : ''}`}
          onClick={handleLimitChange}
        >
          {sizes.large}
        </BundleSizeBtn> */}
      </div>
    </div>
  );
};

export default BoxSizeSelector;
